/**
 * Koji DE — dodanie do koszyka dla bloków z jednym wariantem (`[data-koji-buy-add]`).
 *
 * Formularz celuje w `routes.cart_add_url` i niesie ukryte pola `id` + `quantity`.
 * Ten moduł przechwytuje submit i wysyła go przez `/cart/add.js`, żeby cart drawer
 * otworzył się jak przy natywnym add-to-cart. Gdy czegokolwiek brakuje (wariant, pole),
 * `preventDefault` NIE jest wołane → idzie natywny POST. Cichy „martwy przycisk”
 * (learning #59) nie może więc wystąpić nawet przy błędzie JS.
 *
 * Delegacja na `document`, więc przeżywa re-render sekcji (Section Rendering API).
 *
 * ⚠️ Ta sama logika żyje inline w `blocks/koji-buy-single.liquid`. To celowe —
 *    ten blok napędza PDP upselli i nie chcemy go przy tej zmianie zepsuć. Obie kopie
 *    mają własny guard i własny selektor, więc sobie nie przeszkadzają.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__kojiBuyAddInit) {
  window.__kojiBuyAddInit = true;

  const routeBase = () => {
    const r =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';
    return r.replace(/\/$/, '');
  };

  const add = async (form, variantId, quantity) => {
    const btn = form.querySelector('[data-koji-buy-add-btn]');
    const items = [{ id: variantId, quantity: quantity }];
    const base = routeBase();

    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-loading');
    }

    // sekcje do re-renderu (wiersze koszyka / drawer) — jak natywny add
    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });
    const sections = Array.from(sectionIds).join(',');

    const deferred = CartLinesUpdateEvent.createPromise();

    try {
      form.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((it) => ({
            merchandiseId: 'gid://shopify/ProductVariant/' + it.id,
            quantity: it.quantity,
          })),
          promise: deferred.promise,
        })
      );

      const res = await fetch(base + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();

      let cart = null;
      try {
        const cres = await fetch(base + '/cart.js', { headers: { Accept: 'application/json' } });
        cart = CartLinesUpdateEvent.createCartFromAjaxResponse(await cres.json());
      } catch (err) {
        /* noop — liczbę pozycji drawer dopełni sam */
      }

      deferred.resolve({
        cart,
        detail: {
          sections: data.sections,
          items: data.items,
          source: 'koji-buy-add',
          itemCount: quantity,
        },
      });
    } catch (err) {
      if (typeof deferred.reject === 'function') deferred.reject(err);
      window.location.href = base + '/cart';
    } finally {
      if (btn) {
        btn.removeAttribute('disabled');
        btn.classList.remove('is-loading');
      }
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('[data-koji-buy-add]')) return;

    const idInput = form.querySelector('input[name="id"]');
    const variantId = idInput ? Number(idInput.value) : 0;
    if (!variantId) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const quantity = Number(qtyInput && qtyInput.value) || 1;

    event.preventDefault();
    add(form, variantId, quantity);
  });
}
